import "beercss"
import "@static/css/style.css"
import "@utils/install";
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { initInstall } from "@utils/install";

const firebaseConfig = {
    apiKey: "AIzaSyAyMJKhhAu7OP0E8MycITIZ0OEnBrPKG9A",
    authDomain: "pleatcalculator.firebaseapp.com",
    projectId: "pleatcalculator",
    storageBucket: "pleatcalculator.firebasestorage.app",
    messagingSenderId: "381653396309",
    appId: "1:381653396309:web:6a9e9c732a25261a75dddc",
    measurementId: "G-7YPP3S0K00"
};

function inchesToCentimeters(inches: number, decimals: number = 2): string {
    const cm = inches * 2.54;
    return cm.toFixed(decimals);
}

function roundToSixteenthAndFormat(value: number): string {
    const rounded = Math.round(value * 16);
    const whole = Math.floor(rounded / 16);
    const remainder = rounded % 16;

    const fractionMap: { [key: number]: string } = {
        1: "1/16",
        2: "1/8",
        3: "3/16",
        4: "1/4",
        5: "5/16",
        6: "3/8",
        7: "7/16",
        8: "1/2",
        9: "9/16",
        10: "5/8",
        11: "11/16",
        12: "3/4",
        13: "13/16",
        14: "7/8",
        15: "15/16"
    };

    if (remainder === 0) {
        return `${whole}`;
    } else if (whole === 0) {
        return `${fractionMap[remainder]}`;
    } else {
        return `${whole} ${fractionMap[remainder]}`;
    }
}


function calculatePleatUnderlap(pleatWidth: number, pleatCount: number, totalMaterial: number) {
    const totalPleatWidth = pleatWidth * pleatCount;
    const materialLeft = totalMaterial - totalPleatWidth;
    const underlap = materialLeft / pleatCount;
    return underlap;
}

function calculatePleatWidth(pleatCount: number, waistCircumference: number) {
    return waistCircumference / pleatCount;
}

function calculatePleatCount(waistCircumference: number, pleatWidth: number) {
    return waistCircumference / pleatWidth;
}

function calculateTotalMaterial(pleatWidth: number, pleatCount: number, pleatUnderlap: number): number {
    const totalPleatWidth = pleatWidth * pleatCount;
    const materialLeft = pleatUnderlap * pleatCount;
    return totalPleatWidth + materialLeft;
}

function updateHelperText(input: HTMLInputElement, helper: HTMLSpanElement) {
    helper.innerText = `${roundToSixteenthAndFormat(Number(input.value))} inches (${inchesToCentimeters(Number(input.value))} cm)`;
}

function saveToLocalStorage(input: HTMLInputElement) {
    localStorage.setItem(input.id, input.value);
}

function loadFromLocalStorage(input: HTMLInputElement) {
    const value = localStorage.getItem(input.id);
    if (value) {
        input.value = value;
    }
}

function registerStepButtons(
    input: HTMLInputElement,
    addBtn: HTMLButtonElement,
    removeBtn: HTMLButtonElement,
    decimals: number,
    step: number
) {
    const adjust = (direction: number) => {
        const currentValue = Number(input.value || 0);
        const newValue = currentValue + direction * step;

        input.value = newValue.toFixed(decimals);
        input.dispatchEvent(new Event("input"));
    };

    addBtn.addEventListener("click", () => adjust(+1));
    removeBtn.addEventListener("click", () => adjust(-1));
}

document.addEventListener("DOMContentLoaded", () => {
    initInstall();

    const app = initializeApp(firebaseConfig);
    getAnalytics(app);

    const themeToggle = document.getElementById("theme-toggle") as HTMLInputElement;

    const inputs = {
        waist: document.getElementById("waist-circumference") as HTMLInputElement,
        pleatWidth: document.getElementById("pleat-width") as HTMLInputElement,
        pleatCount: document.getElementById("pleat-count") as HTMLInputElement,
        totalMaterial: document.getElementById("total-material") as HTMLInputElement,
        pleatUnderlap: document.getElementById("pleat-underlap") as HTMLInputElement,
    };

    const helpers = {
        waist: document.getElementById("waist-circumference-helper") as HTMLSpanElement,
        pleatWidth: document.getElementById("pleat-width-helper") as HTMLSpanElement,
        totalMaterial: document.getElementById("total-material-helper") as HTMLSpanElement,
        pleatUnderlap: document.getElementById("pleat-underlap-helper") as HTMLSpanElement,
    };

    const buttons = {
        waist: {
            add: document.getElementById("waist-circumference-add") as HTMLButtonElement,
            minus: document.getElementById("waist-circumference-minus") as HTMLButtonElement,
            decimals: 2,
            step: 0.25,
        },
        pleatWidth: {
            add: document.getElementById("pleat-width-add") as HTMLButtonElement,
            minus: document.getElementById("pleat-width-minus") as HTMLButtonElement,
            decimals: 4,
            step: 0.0625,
        },
        pleatCount: {
            add: document.getElementById("pleat-count-add") as HTMLButtonElement,
            minus: document.getElementById("pleat-count-minus") as HTMLButtonElement,
            decimals: 0,
            step: 1,
        },
        totalMaterial: {
            add: document.getElementById("total-material-add") as HTMLButtonElement,
            minus: document.getElementById("total-material-minus") as HTMLButtonElement,
            decimals: 2,
            step: 1,
        },
        pleatUnderlap: {
            add: document.getElementById("pleat-underlap-add") as HTMLButtonElement,
            minus: document.getElementById("pleat-underlap-minus") as HTMLButtonElement,
            decimals: 4,
            step: 0.25,
        },
    };
    function loadAllInputs() {
        Object.values(inputs).forEach(loadFromLocalStorage);
    }

    function saveAllInputs() {
        Object.values(inputs).forEach(saveToLocalStorage);
    }

    function updateAllHelpers() {
        updateHelperText(inputs.waist, helpers.waist);
        updateHelperText(inputs.pleatWidth, helpers.pleatWidth);
        updateHelperText(inputs.totalMaterial, helpers.totalMaterial);
        updateHelperText(inputs.pleatUnderlap, helpers.pleatUnderlap);
    }

    if (localStorage.getItem("theme") === "dark") {
        document.body.classList.add("dark");
        themeToggle.checked = true;
    }

    themeToggle.addEventListener("change", () => {
        document.body.classList.toggle("dark");
        localStorage.setItem("theme", themeToggle.checked ? "dark" : "light");
    });

    inputs.waist.addEventListener("input", () => {
        const pleatCount = Number(calculatePleatCount(Number(inputs.waist.value), Number(inputs.pleatWidth.value)).toFixed(0));
        inputs.pleatCount.value = pleatCount.toFixed(0);
        inputs.pleatUnderlap.value = calculatePleatUnderlap(Number(inputs.pleatWidth.value), pleatCount, Number(inputs.totalMaterial.value)).toFixed(4);

        updateAllHelpers();
        saveAllInputs();
    });

    inputs.pleatWidth.addEventListener("input", () => {
        const pleatCount = Number(calculatePleatCount(Number(inputs.waist.value), Number(inputs.pleatWidth.value)).toFixed(0));
        inputs.pleatCount.value = pleatCount.toFixed(0);
        inputs.pleatUnderlap.value = calculatePleatUnderlap(Number(inputs.pleatWidth.value), Number(inputs.pleatCount.value), Number(inputs.totalMaterial.value)).toFixed(4);

        updateAllHelpers();
        saveAllInputs();
    });

    inputs.pleatCount.addEventListener("input", () => {
        const pleatWidth = calculatePleatWidth(Number(inputs.pleatCount.value), Number(inputs.waist.value));
        inputs.pleatWidth.value = pleatWidth.toFixed(4);
        inputs.pleatUnderlap.value = calculatePleatUnderlap(Number(inputs.pleatWidth.value), Number(inputs.pleatCount.value), Number(inputs.totalMaterial.value)).toFixed(4);

        updateAllHelpers();
        saveAllInputs();
    });

    inputs.totalMaterial.addEventListener("input", () => {
        const pleatWidth = Number(calculatePleatWidth(Number(inputs.pleatCount.value), Number(inputs.waist.value)).toFixed(4));
        inputs.pleatWidth.value = pleatWidth.toFixed(4);
        inputs.pleatUnderlap.value = calculatePleatUnderlap(Number(inputs.pleatWidth.value), Number(inputs.pleatCount.value), Number(inputs.totalMaterial.value)).toFixed(4);

        updateAllHelpers();
        saveAllInputs();
    });

    inputs.pleatUnderlap.addEventListener("input", () => {
        const totalMaterial = calculateTotalMaterial(Number(inputs.pleatWidth.value), Number(inputs.pleatCount.value), Number(inputs.pleatUnderlap.value));
        inputs.totalMaterial.value = totalMaterial.toFixed(2);

        updateAllHelpers();
        saveAllInputs();
    });

    Object.entries(buttons).forEach(([key, { add, minus, decimals, step }]) => {
        const input = inputs[key as keyof typeof inputs];
        registerStepButtons(input, add, minus, decimals, step);
    });

    if (localStorage.getItem("hide-help-snackbar") !== "true") {
        const snackbar = document.createElement("div");

        snackbar.id = "help-snackbar";
        snackbar.className = "snackbar bottom";
        snackbar.innerHTML = `
        <i>help</i>
        <span class="max">Need help?</span>
        <a class="inverse-primary-text" data-ui="#how-to-use">View Guide</a>
        <a id="hide-help-snackbar" class="inverse-primary-text">Hide</a>
    `;

        document.body.appendChild(snackbar);

        ui(snackbar, 3000);

        snackbar.querySelector("#hide-help-snackbar")?.addEventListener("click", () => {
            localStorage.setItem("hide-help-snackbar", "true");
            snackbar.remove();
        });
    }

    loadAllInputs();
    updateAllHelpers();
});

if ("serviceWorker" in navigator && import.meta.env.PROD) {
    navigator.serviceWorker.register("/service-worker.js");
}